import Swiper from 'swiper/bundle';
import Planimetrie from './planimetrie';

export default {
    init() {
        Planimetrie.init();
        this.initSwiperGallery();

        $('.scrollto-facilities').find('a').click(function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: ($('.facilities').offset().top) - 64,
            }, 1000);
            $('.navbar-collapse').collapse('hide');
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
    initSwiperGallery() {
        new Swiper('.swiper-container', {
            grabCursor: true,
            direction: 'horizontal',
            speed: 850,
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 24,
            autoHeight: false,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            autoplay: {
                delay: 10000,
                disableOnInteraction: true,
            },
            breakpoints: {
                426: {
                    slidesPerView: 3,
                },
                769: {
                    slidesPerView: 4,
                },
                1025: {
                    slidesPerView: 5,
                },
                1441: {
                    slidesPerView: 6,
                },
            },
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/homepage.js